export default {"src":"/_next/static/media/twitch.aac97110.svg","height":92,"width":92,"blurWidth":0,"blurHeight":0};